import React from 'react';
import useStyles, { STYLES, TONE_STYLES, mergeStyles } from '../../useStyles';
import { Tone } from '../../types';

interface INoticeProps {
	tone: Tone;
	title?: string;
	children?: React.ReactNode;
}

const Notice: React.FC<INoticeProps> = ({ tone, title, children }) => {
	const { css, classes } = useStyles();
	return (
		<div role={tone === 'danger' ? 'alert' : 'note'} className={css(mergeStyles(STYLES.notice, TONE_STYLES[tone]))}>
			{title && <span className={classes.noticeTitle}>{title}</span>}
			{children}
		</div>
	);
};

export default Notice;
